<template>
  <div>
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col cols="12" sm="9"> Gestionar Categorias </v-col>

            <template v-if="categorias.length > 0">
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  label="Buscar Categoria"
                  v-model="searchTable"
                >
                </v-text-field>
              </v-col>
            </template>
          </v-row>
        </v-card-title>
        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="categorias"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip
              v-for="accion in accionesModulo"
              :key="accion.id_modulo"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="ejecutarAcciones(accion.accion, item.id)"
                >
                  {{ accion.icono }}
                </v-icon>
              </template>
              <span>{{ accion.modulo }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,
    headersTable: [
      {
        text: "Categoria",
        value: "categoria",
        align: "start",
        width: "400px",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Descripción",
        value: "descripcion",
        align: "start",
        width: "600px",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],
  }),

  mounted() {
    this.$store.dispatch("gestionarCategoriasCampesena");

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    categorias() {
      return this.$store.getters.obtenerCategoriasCampesena;
    },

    accionesModulo() {
      const modulo = this.$store.getters.obtenerAccionesModulo.find(
        (modulo) => modulo.id_modulo == 36
      );
      const acciones = modulo.hijos.filter((modulo) => modulo.accion !== null);
      return acciones;
    },
  },

  methods: {
    ejecutarAcciones(accion, id) {
      this[accion](id);
    },

    detalles(categoria) {
      this.$router.push({
        name: "campesena-categoria-detalles",
        params: { idCategoria: categoria },
      });
    },

    actualizar(categoria) {
      this.$router.push({
        name: "campesena-categoria-actualizar",
        params: { idCategoria: categoria },
      });
    },
    gestionarSaberes(categoria) {
      this.$router.push({
        name: "campesena-saber-gestionar",
        params: { idCategoria: categoria },
      });
    },
  },
};
</script>
